import { Flex } from "@fluentui/react-northstar";
import React from "react";

import { useUserInfo } from "../../actions/useUserInfo";
import { getPageContext } from "../../utils/teamsHelpers";
import { isStaleTrialSub } from "../../utils/userHelpers";
import { PollyIcon } from "../PollyIcon";
import { CyberMondayUpgradeMessage } from "./CyberMondayUpgradeMessage";

type Props = { isMobile: boolean };
export const UpgradeMessageDisplay: React.FC<Props> = ({ isMobile }) => {
  const { user } = useUserInfo();

  const subscription = user.subscriptions.find(sub => sub.state === "active");

  if (subscription || isStaleTrialSub(subscription, user.featureFlags) || isMobile) {
    return null;
  }

  const showCyberMondayMessage = getPageContext() !== "/agile" && user.featureFlags.cyberMonday2023;

  return (
    <Flex column>
      {showCyberMondayMessage && <CyberMondayUpgradeMessage />}
      {!showCyberMondayMessage && (
        <Flex hAlign="center">
          <i>
            <PollyIcon
              icon="arrow-icon"
              style={{
                display: "inline-block",
                transform: "rotate(180deg)",
              }}
            />{" "}
            Get more today!
          </i>
        </Flex>
      )}
    </Flex>
  );
};
